<template>
  <b-collapse :key="componentKey" class="panel">
    <!-- <div slot="trigger" class="panel-heading">
      <strong>Azioni marketing</strong>
    </div>-->
    <div class="panel-block">
      <table class="table is-fullwidth is-narrow">
        <!-- <thead>
          <tr>
            <th>Azione</th>
            <th>Descrizione</th>
            <th>Data</th>
            <th>Note</th>
            <th>Azione succ.</th>
            <th></th>
          </tr>
        </thead>-->
        <tbody>
          <tr v-for="(action, key) in formData" :key="action.id">
            <td>
              <b-field
                :message="showErrors[key]['action']"
                :type="showErrors[key]['action'] ? 'is-danger' : ''"
              >
                <b-select v-model="action.action" expanded size="is-small">
                  <option
                    v-for="option in [
                      'Appuntamento',
                      'Conferma ordine',
                      'Gestione rinnovi',
                      'Invio Mail',
                      'Invio Newsletter',
                      'Invio preventivo',
                      'Mail Info',
                      'Partecipazione Evento / Formazione',
                      'Recall',
                      'Richiesta Info cliente / GS'
                    ]"
                    :key="option"
                    :value="option"
                  >
                    {{ option }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td>
              <b-field
                :message="showErrors[key]['description']"
                :type="showErrors[key]['description'] ? 'is-danger' : ''"
              >
                <b-input v-model="action.description" size="is-small"></b-input>
              </b-field>
            </td>
            <td width="150">
              <b-field
                :message="showErrors[key]['date']"
                :type="showErrors[key]['date'] ? 'is-danger' : ''"
              >
                <datepicker
                  size="is-small"
                  :value="action.date ? new Date(action.date) : null"
                  @input="formData[key]['date'] = formatDate($event)"
                ></datepicker>
              </b-field>
            </td>
            <td>
              <b-field
                :message="showErrors[key]['notes']"
                :type="showErrors[key]['notes'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="action.notes"
                  size="is-small"
                  @focus="modalEdit(action, 'notes')"
                ></b-input>
              </b-field>
            </td>
            <td width="150">
              <b-field
                :message="showErrors[key]['next_action']"
                :type="showErrors[key]['next_action'] ? 'is-danger' : ''"
              >
                <div class="field has-addons">
                  <p class="control">
                    <datepicker
                      size="is-small"
                      :value="action.next_action ? new Date(action.next_action) : null"
                      @input="formData[key]['next_action'] = formatDate($event)"
                    ></datepicker>
                  </p>
                  <p class="control">
                    <button
                      class="button is-small is-light"
                      type="button"
                      @click="formData[key]['next_action'] = null"
                    >
                      X
                    </button>
                  </p>
                </div>
              </b-field>
            </td>
            <td>
              <button class="button is-small" @click="formData.splice(key, 1)">
                <b-icon icon="minus-circle" type="is-danger" />
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="9">
              <div class="buttons">
                <button
                  class="button is-success is-small"
                  @click="formData.push({ customer: customerId })"
                >
                  <b-icon icon="plus"></b-icon>
                  <span>Aggiungi azione di marketing</span>
                </button>
                <button
                  v-if="formHasEdits"
                  class="button is-small"
                  @click="reset"
                >
                  <b-icon icon="undo"></b-icon>
                  <span>Annulla</span>
                </button>
                <button
                  v-if="formHasEdits"
                  class="button is-primary is-small"
                  type="submit"
                  @click="submit()"
                >
                  <b-icon icon="save"></b-icon>
                  <span>Salva</span>
                </button>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </b-collapse>
</template>

<script>
import cloneDeep from "lodash/cloneDeep"
import { call } from "vuex-pathify"

import dateHelpers from "@/mixins/dateHelpers"

export default {
  mixins: [dateHelpers],
  props: {
    customerId: {
      type: Number,
      required: true
    },
    marketingActions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      componentKey: 0, // used to force rerender
      formData: cloneDeep(this.marketingActions),
      errors: []
    }
  },
  computed: {
    formHasEdits() {
      return (
        JSON.stringify(this.marketingActions) != JSON.stringify(this.formData)
      )
    },
    showErrors() {
      if (this.errors.length > 0) {
        return this.errors
      } else {
        let elements = []
        this.formData.forEach(() => {
          elements.push({})
        })
        return elements
      }
    }
  },
  methods: {
    submitAction: call("marketingActions/update"),
    reset() {
      this.errors = []
      this.formData = cloneDeep(this.marketingActions)
      this.componentKey += 1
    },
    async submit() {
      try {
        await this.submitAction({
          customerId: this.customerId,
          data: this.formData
        })
        this.reset()
        this.$toast.open({
          message: "Modificato con successo",
          type: "is-success"
        })
      } catch (response) {
        // show errors in form
        this.errors = response.data
      }
    }
  }
}
</script>
